import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHistory, faEye, faBullseye, faMicrochip, faHandshake, faShieldHalved, faLightbulb 
} from '@fortawesome/free-solid-svg-icons';
import './About.css';

const About = () => {
    const values = [
        { title: "Rigor Técnico", desc: "No tomamos atajos. Cada línea de código es auditada para garantizar eficiencia y seguridad.", icon: faMicrochip },
        { title: "Transparencia", desc: "Comunicación honesta y reportes claros sobre el avance real de cada proyecto.", icon: faHandshake },
        { title: "Integridad de Datos", desc: "La privacidad es nuestra prioridad, implementando protocolos de seguridad desde el diseño.", icon: faShieldHalved },
        { title: "Innovación Útil", desc: "Usamos tecnología de vanguardia solo cuando aporta valor real al negocio del cliente.", icon: faLightbulb }
    ];

    return (
        <section id="historia" className="about-section">
            <div className="about-glow-bg"></div>
            
            <motion.div 
                className="about-header"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
            >
                <div className="about-icon-box">
                    <FontAwesomeIcon icon={faHistory} />
                </div>
                <h2 className="about-title">Nuestra Trayectoria</h2>
                <p className="about-main-text">
                    Fundada en 2024, <strong>3 Vértices</strong> nació de la convergencia entre la ingeniería de precisión y la pasión por resolver desafíos complejos. Diseñamos arquitecturas digitales que sirven como el núcleo operativo de empresas con visión de futuro.
                </p>
            </motion.div>
            
            <div className="mission-vision-container">
                <motion.div 
                    className="about-card glass-card-dark"
                    whileHover={{ y: -10 }}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                >
                    <div className="card-icon blue">
                        <FontAwesomeIcon icon={faBullseye} />
                    </div>
                    <h3 className="card-title">Nuestra Misión</h3>
                    <p className="card-text">
                        Empoderar organizaciones mediante ingeniería de software a medida, transformando procesos manuales en ecosistemas digitales automatizados, escalables y seguros.
                    </p>
                </motion.div>
                
                <motion.div 
                    className="about-card glass-card-dark"
                    whileHover={{ y: -10 }}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                >
                    <div className="card-icon cyan">
                        <FontAwesomeIcon icon={faEye} />
                    </div>
                    <h3 className="card-title">Nuestra Visión</h3>
                    <p className="card-text">
                        Consolidarnos para 2030 como el referente regional en desarrollo de software de alta complejidad e innovación en arquitecturas de nube robustas.
                    </p>
                </motion.div>
            </div>

            {/* --- NUEVA SECCIÓN: VALORES ESTRATÉGICOS --- */}
            <div className="values-section">
                <h3 className="values-main-title">Valores Fundamentales</h3>
                <div className="values-grid">
                    {values.map((v, i) => (
                        <motion.div 
                            key={i} 
                            className="value-item"
                            initial={{ opacity: 0, y: 15 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: i * 0.1 }}
                            viewport={{ once: true }}
                        >
                            <FontAwesomeIcon icon={v.icon} className="value-icon" />
                            <h4>{v.title}</h4>
                            <p>{v.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default About;